import { render, staticRenderFns } from "./PY-Waybill.vue?vue&type=template&id=25f6225e&scoped=true&"
import script from "./PY-Waybill.vue?vue&type=script&lang=js&"
export * from "./PY-Waybill.vue?vue&type=script&lang=js&"
import style0 from "./PY-Waybill.vue?vue&type=style&index=0&id=25f6225e&scoped=true&lang=css&"
import style1 from "./PY-Waybill.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f6225e",
  null
  
)

export default component.exports